// extracted by mini-css-extract-plugin
export var hidden = "_tf-0";